import React from 'react';
export const PublicDataContext = React.createContext({});
export const usePublicData = () => React.useContext(PublicDataContext);